module.exports = __webpack_public_path__ + "img/image12.5f1f4ed7.jpg";